import { render } from "./CustomLinkLogin.vue?vue&type=template&id=5a669af1"
import script from "./CustomLinkLogin.vue?vue&type=script&lang=js"
export * from "./CustomLinkLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__